import { render } from "./BusinessDetailsModal.vue?vue&type=template&id=35e11854&scoped=true"
import script from "./BusinessDetailsModal.vue?vue&type=script&lang=js"
export * from "./BusinessDetailsModal.vue?vue&type=script&lang=js"

import "./BusinessDetailsModal.vue?vue&type=style&index=0&id=35e11854&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e11854"]])

export default __exports__